import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=43679bca&scoped=true"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"
import style0 from "./SendMail.vue?vue&type=style&index=0&id=43679bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43679bca",
  null
  
)

export default component.exports